export default from './Tags';



// WEBPACK FOOTER //
// ./src/containers/Tags/index.js